// @flow

export const MODEL = 'BillingInfo'

// Api End Point
export const URL = 'hefty/clientbillingaddress/'

// Model Properties
export const PROP_ID = 'id'
export const PROP_FARM_NAME = 'farm_name'
export const PROP_EMAIL = 'email'
export const PROP_COUNTRY = 'country'
export const PROP_ADDRESS = 'address'
export const PROP_POSTAL_CODE = 'postal_code'
export const PROP_CITY = 'city'
export const PROP_PROVINCE = 'province'
export const PROP_PHONE = 'phone'
export const PROP_MOBILE_PHONE = 'mobile_phone'
export const PROP_FAX = 'fax'
export const PROP_CLIENT = 'client'
export const PROP_DEFAULT_UNITS = 'units'
